import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery'

class LuckyDrawWheel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vouchers: null,
            angles: 0,
            draw: null,
            isDrawed: false,
            hide: false,
            centerText: "GO!",
            colors: {
                wheelColorOdd: "#f5d322",
                wheelColorEven: "#f7e52a",
                wheelTextColor: "#e62f24",
                arrow: "#e64b14",
                centerText: "white",
                center: "#f9f07c"
            }
        };
    }

    getVouchers() {
        $.ajax({
            url: "/luckyvoucher/draw",
            type: "get",
            success: response => {
                this.setState({
                    vouchers: response
                })
            },
            error: (error) => {
                console.log(error)
            }
        })
    }

    startDraw() {
        this.props.started()
        //转盘旋转
        //转盘旋转过程“开始抽奖”按钮无法点击
        $('#tupBtn').attr("disabled", true);
        //“开始抽奖”按钮无法点击恢复点击
        $.ajax({
            url: "/draw",
            type: "get",
            success: response => {
                $('#tupBtn').attr("disabled", true);

                if (response.drawID !== undefined && !isNaN(response.drawID)) {

                    let voucherID = response.drawID;
                    let voucher;
                    for (let i = 0; i < this.state.vouchers.length; i++) {
                        let index;
                        if (this.state.vouchers[i] === null && voucherID === -1) {
                            index = i;
                        } else if (this.state.vouchers[i] !== null && this.state.vouchers[i].id === voucherID) {
                            index = i;
                        }
                        if (index !== undefined) {
                            voucher = this.state.vouchers[i];
                            this.runCup(index);
                            break;
                        }
                    }

                    setTimeout(_ => {
                        $('#tupBtn').removeAttr("disabled", false);
                        this.setState({
                            draw: voucherID === -1 ? voucherID : voucher,
                            hide: true
                        });
                        setTimeout(_ => {
                            this.props.ended()
                        },3000)
                    }, 6000);
                }

            },
            error: (error) => {
                this.props.ended()
                alert(error);
                $('#tupBtn').attr("disabled", false);
            }
        })

        this.setState({
            centerText: lang.good_luck
        });
        this.initPoint();
    }

    checkIsDrawed() {
        this.setState({
            isDrawed: true
        });
    }

    render() {
        let body;
        if (this.state.draw !== null) {
            if (this.state.draw === -1) {
                body = (
                    <div className="text-center">
                        <h1>{lang.no_luck}</h1>
                        <h2>{lang.no_luck_desc}</h2>
                    </div>
                );
            } else {
                body = (
                    <div className="text-center">
                        <h1>{lang.so_lucky}</h1>
                        <h2>{lang.so_lucky_desc}</h2>
                        <h2>{this.state.draw.voucher.display_name}</h2>
                    </div>
                );
            }
        } else {
            body = (
                <div className="turnplate_box">
                    <canvas id="myCanvas" width="300px" height="300px">{lang.browser_no_support}</canvas>
                    <canvas id="myCanvas01" width="200px" height="200px">{lang.browser_no_support}</canvas>
                    <canvas id="myCanvas03" width="200px" height="200px">{lang.browser_no_support}</canvas>
                    <canvas id="myCanvas02" width="150px" height="150px">{lang.browser_no_support}</canvas>
                    <button id="tupBtn" onClick={this.startDraw.bind(this)} className="turnplatw_btn"></button>
                </div>
            );
        }

        return body
    }

    componentDidMount() {
        this.getVouchers()
        var canvas = document.getElementById('myCanvas');
        var canvas01 = document.getElementById('myCanvas01');
        var canvas03 = document.getElementById('myCanvas03');
        var canvas02 = document.getElementById('myCanvas02');
        this.setState({
            ctxs: {
                wheel: canvas.getContext('2d'),
                arrow: canvas01.getContext('2d'),
                center: canvas02.getContext('2d'),
                centerContent: canvas03.getContext('2d'),
            }
        });
    }

    componentDidUpdate() {
        if (this.state.ctxs !== null && this.state.vouchers != null) {
            this.createCircle();
            this.createCirText();
            this.initPoint();
        }
    }
    createCircle() {
        var startAngle = 0;//扇形的开始弧度
        var endAngle = 0;//扇形的终止弧度
        //画一个8等份扇形组成的圆形
        let ctx = this.state.ctxs.wheel;
        for (var i = 0; i < 8; i++) {
            startAngle = Math.PI * (i / 4 - 1 / 8);
            endAngle = startAngle + Math.PI * (1 / 4);
            ctx.save();
            ctx.beginPath();
            ctx.arc(150, 150, 100, startAngle, endAngle, false);
            ctx.lineWidth = 120;
            if (i % 2 === 0) {
                ctx.strokeStyle = this.state.colors.wheelColorEven;
            } else {
                ctx.strokeStyle = this.state.colors.wheelColorOdd;
            }
            ctx.stroke();
            ctx.restore();
        }
    }
    createCirText() {
        let ctx = this.state.ctxs.wheel;
        ctx.textAlign = 'start';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = this.state.colors.wheelTextColor;
        var step = 2 * Math.PI / 8;
        for (var i = 0; i < 8; i++) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(150, 150);
            ctx.rotate(i * step);
            ctx.font = "bold 22px consolas";
            ctx.fillStyle = this.state.colors.wheelTextColor;
            if (this.state.vouchers[i] !== null) {
                ctx.fillText(this.state.vouchers[i].voucher.display_name, -30, -115, 60);
            }else{
                ctx.fillText("Thank You", -30, -115, 60);
            }
            // ctx.font = " 14px Microsoft YaHei";
            // ctx.fillText(info1[i], -30, -95, 60);
            ctx.closePath();
            ctx.restore();
        }
    }

    initPoint() {
        let ctx1 = this.state.ctxs.arrow;
        let ctx2 = this.state.ctxs.center;
        let ctx3 = this.state.ctxs.centerContent;
        //箭头指针
        ctx1.beginPath();
        ctx1.moveTo(100, 46);
        ctx1.lineTo(90, 62);
        ctx1.lineTo(110, 62);
        ctx1.lineTo(100, 46);
        ctx1.fillStyle = this.state.colors.arrow;
        ctx1.fill();
        ctx1.closePath();
        //中间小圆
        ctx3.beginPath();
        ctx3.arc(100, 100, 40, 0, Math.PI * 2, false);
        ctx3.fillStyle = this.state.colors.arrow;
        ctx3.fill();
        ctx3.closePath();
        //小圆文字
        ctx3.font = "Bold 20px consolas";
        ctx3.textAlign = 'center';
        ctx3.textBaseline = 'middle';
        ctx3.fillStyle = this.state.colors.centerText;
        ctx3.beginPath();
        ctx3.fillText(this.state.centerText, 100, 100, 40);
        // ctx3.fillText('抽奖', 80, 110, 40);
        ctx3.fill();
        ctx3.closePath();
        //中间圆圈
        ctx2.beginPath();
        ctx2.arc(75, 75, 50, 0, Math.PI * 2, false);
        ctx2.fillStyle = this.state.colors.center;
        ctx2.fill();
        ctx2.closePath();
    }

    //转盘旋转
    runCup(index) {
        //2160 * rotNum + (1800 + );
        // Add 2160 to spin back to original position before start 2nd or 3rd spin
        let extraSpin = 1800; // 1800 1 spin
        let angles = (-45 * index) + extraSpin;
        var degValue = `rotate(${angles}deg)`;
        $('#myCanvas').css('-o-transform', degValue);           //Opera
        $('#myCanvas').css('-ms-transform', degValue);          //IE浏览器
        $('#myCanvas').css('-moz-transform', degValue);         //Firefox
        $('#myCanvas').css('-webkit-transform', degValue);      //Chrome和Safari
        $('#myCanvas').css('transform', degValue);
    }

    drawWheel() {

        //各奖项对应的旋转角度及中奖公告内容
        function probability() {
            //获取随机数
            var num = parseInt(Math.random() * (7 - 0 + 0) + 0);


            try {
                angles = 2160 * rotNum + (1800 + (45 * num));
                let infoIndex = 0;
                if (num !== 0) {
                    infoIndex = 8 - num;
                }
                notice = info[infoIndex];
            } catch (error) {
                //概率
                if (num === 0) {
                    angles = 2160 * rotNum + 1800;
                    notice = info[0];
                }
                //概率
                else if (num === 1) {
                    angles = 2160 * rotNum + 1845;
                    notice = info[7];
                }
                //概率
                else if (num === 2) {
                    angles = 2160 * rotNum + 1890;
                    notice = info[6];
                }
                //概率
                else if (num === 3) {
                    angles = 2160 * rotNum + 1935;
                    notice = info[5];
                }
                //概率
                else if (num === 4) {
                    angles = 2160 * rotNum + 1980;
                    notice = info[4];
                }
                //概率
                else if (num === 5) {
                    angles = 2160 * rotNum + 2025;
                    notice = info[3];
                }
                //概率
                else if (num === 6) {
                    angles = 2160 * rotNum + 2070;
                    notice = info[2];
                }
                //概率
                else if (num === 7) {
                    angles = 2160 * rotNum + 2115;
                    notice = info[1];
                }
            }
        }
    }
}

LuckyDrawWheel.propTypes = {
    merchant_id: PropTypes.number.isRequired,
    started: PropTypes.func,
    ended: PropTypes.func
}

export default LuckyDrawWheel;